// This is a wrapper around Kissmetrics which is added
// by lp-webapp to the builder HTML template

export function trackUserEvent(subject, action, properties = {}) {
  if (window._kmq) {
    window._kmq.push(['record', `builder.${subject}.${action}`, properties]);
  }
}



// WEBPACK FOOTER //
// ./src/ui-user-tracking.js